/** @jsx jsx */
import React, { Fragment, useContext } from 'react'
import { jsx, IconButton, Box, Flex, Link as ThemeUiLink } from 'theme-ui'
import Link, { StyledLink } from '../../components/shared/Typography/Link/Link'
import Body from '../../components/shared/Typography/Body/Body'
import { CountryContext } from '../../gatsby/wrap-wroot-element'
import { useWindowSize } from '../../hooks/useWindowSize'
import styled from '@emotion/styled'

const CompanyInfo = props => {
  const TextContainer = styled(Body)``

  return (
    <>
      <TextContainer
        variant="companyInfoText"
        sx={{ textAlign: ['center', 'center', 'right'] }}
      >
        {props.address}
      </TextContainer>

      <TextContainer
        variant="companyInfoText"
        sx={{ textAlign: ['center', 'center', 'right'] }}
      >
        {props.supportHours}
      </TextContainer>

      <TextContainer
        variant="companyInfoText"
        sx={{ fontWeight: '800', textAlign: ['center', 'center', 'right'] }}
      >
        Call Us: {props.supportNumber}
      </TextContainer>

      <ThemeUiLink href={`mailto:${props.supportEmail}`} target="_blank">
        <TextContainer
          variant="companyInfoText"
          sx={{ fontWeight: '800', textAlign: ['center', 'center', 'right'] }}
        >
          Email Us: {props.supportEmail}
        </TextContainer>
      </ThemeUiLink>

      <Flex
        sx={{
          justifyContent: ['center', null, 'flex-end'],
        }}
      >
        <IconButton
          sx={{
            width: ['186px'],
            overflow: 'visible',
            marginTop: ['25px', null, '15px'],
            marginBottom: '30px',
            display: 'flex',
            marginLeft: ['auto', 'auto', '0px'],
            marginRight: ['auto', 'auto', '0px'],
            height: 'auto',
          }}
        >
          <img sx={{ objectFit: 'contain' }} src={props.img} alt="jaxxon" />
        </IconButton>
      </Flex>
    </>
  )
}

export default CompanyInfo
